import css from '@styled-system/css';
/*
  This is a handful utility function that handling type mismatch between styled-system and styled-components
*/
const cssWrapper = (styles) => css(styles);
export default cssWrapper;
